import { Instruction, OpCode } from '../internal.js';
/**
 * Load By Ref Instruction.
 *
 * Loads an instance by the given Jig Ref.
 */
export class LoadInstruction extends Instruction {
    outputId;
    constructor(outputId) {
        super(OpCode.LOAD);
        this.outputId = outputId;
    }
}
/**
 * Load Args Serializer object - implements the Serializable interface.
 */
export const LoadArgsSerializer = {
    read(buf) {
        const outputId = buf.readFixedBytes(32);
        return new LoadInstruction(outputId);
    },
    write(buf, instruction) {
        buf.writeFixedBytes(instruction.outputId);
        return buf;
    }
};
